const Button = ({ title, option }: any) => {
  return (
    <div className="">
      <button className="w2st-button text-tmd">{title}</button>
    </div>
  );
};

export default Button;
